export default __webpack_public_path__ + "static/media/observation.7a9be79a.svg";